import React from 'react';
import { usePublicAppContext } from '../contexts/PublicAppContext';
import StocktagBrandLogo from './StocktagBrandLogo';
import InteractiveDotGridCanvas from './ui/InteractiveDotGridCanvas';
import { normalizeTheme } from '../utils/theme';
import '../styles/LoadingScreen.css';

const LOADER_DOT_COLORS = Object.freeze({
  light: '#64748b',
  dark: '#64748b',
  'true-dark': '#74777f',
  neon: '#0ae448'
});

const LoadingScreen = ({ theme: themeOverride = null }) => {
  const { texts, theme: publicTheme = 'true-dark' } = usePublicAppContext();
  const loadingLabel = texts?.loading_text || 'Loading';
  const resolvedTheme = normalizeTheme(themeOverride || publicTheme);
  const dotColor = LOADER_DOT_COLORS[resolvedTheme];

  return (
    <div
      className="stocktag-loading-screen"
      data-theme={resolvedTheme}
      role="status"
      aria-live="polite"
      aria-atomic="true"
      aria-busy="true"
      aria-label={`Stocktag.ai · ${loadingLabel}`}
    >
      <InteractiveDotGridCanvas
        color={dotColor}
        dotSize={1.5}
        gap={28}
        activeScale={1.9}
      />

      <div className="stocktag-loading-screen__content" aria-hidden="true">
        <div className="stocktag-loading-screen__pill">
          <StocktagBrandLogo
            variant="full"
            className="stocktag-loading-screen__logo"
            decorative
          />

          <span className="stocktag-loading-screen__spinner">
            <span className="stocktag-loading-screen__spinner-track" />
            <span className="stocktag-loading-screen__spinner-arc" />
          </span>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
